module.exports = __webpack_public_path__ + "static/toronto-8-bit-long-left-735d74e4907093304a6c41cd7848d9f6.png";